import React from 'react';
import styled from 'styled-components';
import { SkeletonList, token } from '@bynder/design-system';

export function ResultsSkeleton() {
	return (
		<StyledWrapper data-testid="spotlight-results-skeleton">
			<SkeletonList itemRender={<SkeletonList.Item isThumbnailShow isSubtextShow />} />
		</StyledWrapper>
	);
}

const StyledWrapper = styled.div`
	padding: ${token.spacing4} ${token.spacing5};
`;
